import React from "react";
import DocumentsSection from "./DocumentsSection";

const DocumentsModalBody = () => <DocumentsSection />;

// MUST BE "BodyContent" because of WBCModal
DocumentsModalBody.displayName = "BodyContent";

export default DocumentsModalBody;
